import { gql } from '@common/hooks';
import {
  InvoiceStateType,
  ReverseInvoiceListItemFragment,
  ReverseInvoiceListItemFragmentType,
  ReverseInvoiceReviewFragment,
  ReverseInvoiceReviewFragmentType,
} from '@pay-bill/graphql/fragments';
import { HistoryInfoFragment } from '@common/graphql';

export const PaginatedRevInvoicesQuery = gql`
  query PaginatedReverseInvoicesList(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: WorksReverseInvoiceOrderField
    $filters: WorksReverseInvoiceFilterInput
  ) {
    page: paginatedWorksReverseInvoices(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
    ) {
      values: worksReverseInvoices {
        ...ReverseInvoiceListItemFragment
      }
      totalCount
    }
  }
  ${ReverseInvoiceListItemFragment}
`;

export type PaginatedRevInvoicesResponse = {
  page: {
    values: ReverseInvoiceListItemFragmentType[];
    totalCount: number;
  };
};

export const RevInvoiceFiltersQuery = gql`
  query WorksReverseInvoiceFilters {
    values: worksReverseInvoiceFilters {
      organizations {
        id
        name
      }
      states
    }
  }
`;

export type PaginatedRevInvoiceArg = {
  limit: number;
  offset: number;
  orderDirection: 'ASC' | 'DESC';
  orderField:
    | 'BILLING_AMOUNT'
    | 'CODE'
    | 'CREATED_AT'
    | 'ORGANIZATION'
    | 'STATE';
  filters: {
    code?: string[];
    date?: string[];
    organization?: string[];
    states?: string[];
    worksProfile?: string[];
  };
};

export type RevInvoiceFiltersQueryType = {
  values: {
    organizations: { id: string; name: string }[];
    states: InvoiceStateType[];
  };
};

export const RevInvoiceReviewQuery = gql`
  query RevInvoiceReview($id: String!) {
    worksReverseInvoice(id: $id) {
      ...ReverseInvoiceReviewFragment
    }
  }
  ${ReverseInvoiceReviewFragment}
`;

export type RevInvoiceReviewQueryResponse = {
  worksReverseInvoice: ReverseInvoiceReviewFragmentType;
};

export type RevInvoiceReviewQueryArgs = {
  id: string;
};

export const RevInvoiceHoursTab = gql`
  query RevInvoiceHoursTab($id: String!) {
    worksReverseInvoice(id: $id) {
      id
      worksInvoice {
        id
        disputeClosingDate
        canSubmitDispute {
          value
        }
      }
    }
  }
`;

export const RevInvoiceHistoryTab = gql`
  query RevInvoiceHistoryTab($id: String!) {
    worksReverseInvoice(id: $id) {
      id
      history {
        ...HistoryInfoFragment
      }
    }
  }
  ${HistoryInfoFragment}
`;
